import { CustomColumn } from '../../types/customColumn';
import { PrinterDTO } from '../../types/hardware/PrinterTypes';

export const printerColumns: CustomColumn<PrinterDTO>[] = [
  {
    Header: 'Nombre',
    accessor: 'name',
    customCell: ({ row }) => (
      <span className="text-gray-700 dark:text-gray-300 text-sm">
        {row.original.name}
      </span>
    ),
  },
  {
    Header: 'Modelo',
    accessor: 'model',
    customCell: ({ row }) => (
      <span className="text-sm">{row.original.model}</span>
    ),
  },
  {
    Header: 'Tipo',
    accessor: 'printerType',
    customCell: ({ row }) => (
      <span className="text-sm">{row.original.printerType}</span>
    ),
  },
  {
    Header: 'Dirección IP',
    accessor: 'ipAddress',
    customCell: ({ row }) => (
      <span className="text-sm">{row.original.ipAddress}</span>
    ),
  },
  {
    Header: 'Puerto',
    accessor: 'port',
    customCell: ({ row }) => (
      <span className="text-sm">{row.original.port}</span>
    ),
  },
  {
    Header: 'Sucursal',
    accessor: 'branchName',
    customCell: ({ row }) => (
      <span className="text-gray-700 dark:text-gray-300 text-sm">
        {row.original.branchName ?? '—'}
      </span>
    ),
  },
  {
    Header: 'Estado',
    accessor: 'active',
    customCell: ({ row }) => {
      const status = row.original.active ? 'Activo' : 'Inactivo';
      const badgeClass = row.original.active
        ? 'bg-[#3CA745] text-white'
        : 'bg-[#DC3545] text-white';

      return (
        <span
          className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${badgeClass}`}
        >
          {status}
        </span>
      );
    },
  },
];
